import { render, staticRenderFns } from "./business-section-1.vue?vue&type=template&id=0a7eaae2&"
import script from "./business-section-1.vue?vue&type=script&lang=js&"
export * from "./business-section-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports